export default "__VITE_ASSET__8a108821__"